import React, { useState, useEffect } from "react";
import {
  Card,
  Form,
  Row,
  Col,
  Button,
  Modal,
  Container,
  Nav,
} from "react-bootstrap";
import { useForm } from "@formspree/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faHeadset } from "@fortawesome/free-solid-svg-icons";
import PageBanner from "../commoncomponents/Pagebanner";

const cardStyle = {
  background: "linear-gradient(to right, #0f2027, #203a43, #2c5364)",
  color: "#f1f1f1",
  fontFamily: "'Poppins', sans-serif",
  border: "none",
};

function ContactCard() {
  return (
    <Card className="shadow-lg rounded-3 p-4 h-110" style={cardStyle}>
      <Card.Body>
        <h1 className="fw-bold mb-3 text-center" style={{ color: "#00d9ff" }}>
          Reach Us
        </h1>
        <h5>Address</h5>
        <p>Morbi, Gujarat, India.</p>
        <br />
        <h5>Email</h5>
        <p>
          <a
            href="mailto:quality@varayqcservices.com"
            className="text-light text-decoration-underline"
          >
            quality@varayqcservices.com{" "}
          </a>
        </p>
        <p>
          <a
            href="mailto:varayqaservices@gmail.com"
            className="text-light text-decoration-underline"
          >
            varayqaservices@gmail.com{" "}
          </a>
        </p>
        {/* 
        <h5>GST-IN</h5>
        <p className="fw-bold">24BONPJ6123B1ZB</p> */}
        <br />
        <h5>Call Us</h5>
        <p>Phone: +91 90169 72420</p>

        <div className="d-flex gap-3 justify-content-center mt-4 p-1">
          <Nav.Link
            href="https://www.instagram.com/varay_qc_services/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon
              icon={faInstagram}
              size="2x"
              className="header-icon"
            />
          </Nav.Link>
          <Nav.Link
            href="https://wa.me/919016972420"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon
              icon={faWhatsapp}
              size="2x"
              className="header-icon"
            />
          </Nav.Link>

          <Nav.Link href="tel:+919016972420">
            <FontAwesomeIcon
              icon={faHeadset}
              size="2x"
              className="header-icon"
            />
          </Nav.Link>
        </div>
      </Card.Body>
    </Card>
  );
}

function ContactForm() {
  const [countryCode, setCountryCode] = useState("+91");
  const [number, setNumber] = useState("");
  const [fieldErrors, setFieldErrors] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [state, handleSubmit] = useForm("mdkzbzll");

  useEffect(() => {
    if (state.succeeded) {
      setShowModal(true);
    }
  }, [state.succeeded]);

  const handleChangeCode = (e) => {
    const value = e.target.value;
    if (/^\+?\d{0,3}$/.test(value)) setCountryCode(value);
  };

  const handleChangeNumber = (e) => {
    const value = e.target.value;
    if (/^\d{0,10}$/.test(value)) {
      setNumber(value);
      setFieldErrors(value.length > 0 && value.length !== 10);
    }
  };

  return (
    <>
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Thank You!</Modal.Title>
        </Modal.Header>
        <Modal.Body>Your message has been sent successfully.</Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Card className="shadow-lg rounded-3 p-4 h-100" style={cardStyle}>
        <Card.Body>
          <h1 className="fw-bold mb-3 text-center" style={{ color: "#00d9ff" }}>
            Contact Us
          </h1>

          <Form onSubmit={handleSubmit}>
            <Row className="mb-4">
              <Col md={6}>
                <Form.Control
                  type="text"
                  name="firstName"
                  placeholder="First Name*"
                  required
                />
              </Col>
              <Col md={6}>
                <Form.Control
                  type="text"
                  name="lastName"
                  placeholder="Last Name*"
                  required
                />
              </Col>
            </Row>

            <Form.Control
              type="email"
              name="email"
              placeholder="abc@gmail.com*"
              className="mb-4"
              required
            />

            <Row className="mb-4">
              <Col md={4}>
                <Form.Control
                  type="text"
                  name="countrycode"
                  value={countryCode}
                  placeholder="+91"
                  required
                  onChange={handleChangeCode}
                />
              </Col>
              <Col md={8}>
                <Form.Control
                  type="text"
                  name="phoneno"
                  value={number}
                  placeholder="Phone no.*"
                  required
                  onChange={handleChangeNumber}
                />
              </Col>
            </Row>

            {fieldErrors && (
              <div className="text-danger text-center mb-3">
                Phone number must be 10 digits
              </div>
            )}

            <Form.Control
              as="textarea"
              name="message"
              rows={4}
              className="mb-4"
              placeholder="Your message"
              required
            />

            <Button
              type="submit"
              variant="primary"
              className="w-100"
              disabled={state.submitting}
            >
              Send Message
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </>
  );
}

export default function ContactUs() {
  return (
    <>
      <div>
        <PageBanner title="Contact Us" />
      </div>
      <Container className="my-5">
        <Row className="g-4">
          <Col xs={12} md={6}>
            <ContactForm />
          </Col>
          <Col xs={12} md={6}>
            <ContactCard />
          </Col>
        </Row>
      </Container>
    </>
  );
}
